// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectsList_wrapper__pTPO3","fullWidth":"ProjectsList_fullWidth__xz55r","space":"ProjectsList_space__YcUdF"};